<template>
  <div class="popup__plant">
    <!-- Popup Model - for select batch number in plants -->
    <vs-popup classContent="popup-example add__plants_batch" title="Serial List" :active.sync="is_return_plants_popup_active">
      <form @submit.prevent="addPlantsBatch" v-if="products_active_plants">
        <!-- batch serial number details -->
        <vs-table :data="products_active_plants" class="plants_batch_details vs-con-loading__container mt-5">
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th>Batch Serial No</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <!-- Plant Select Box -->
              <vs-td class="plant__check_box">
                <vs-checkbox v-model="plantIds" :id="data[indextr].plantId" :vs-value="data[indextr].plantId" />
              </vs-td>

              <!-- plant batch numbers -->
              <vs-td :data="data[indextr].plant.serialNumber">
                {{ data[indextr].plant.serialNumber }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- footer action btn -->
        <div class="footer text-right">
          <vs-button class="mt-2 text-sm p-3" color="danger" type="filled" @click="$emit('update:is_model_open', false)"> Close </vs-button>

          <button class="mt-2 ml-2 text-sm vs-component vs-button vs-button-primary vs-button-filled p-3" type="submit">Add</button>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'PlantPopup',

  props: {
    is_model_open: Boolean,
    products_active_plants: Array
  },

  data() {
    return {
      plantIds: []
    }
  },

  computed: {
    // close the poup
    is_return_plants_popup_active: {
      get() {
        return this.is_model_open
      },
      set(val) {
        this.plantIds = []
        this.$emit('update:is_model_open', val)
      }
    }
  },

  // methods
  methods: {
    async addPlantsBatch() {
      // send the selected plants
      this.$emit('return_plants', this.plantIds)

      this.is_return_plants_popup_active = false
    }
  },

  beforeRouteLeave(_, __, next) {
    this.is_return_plants_popup_active = false
    next()
  }
}
</script>

<style>
</style>